import React from 'react';
import {Avatar, AvatarGroup, Box, HStack, VStack} from '@chakra-ui/react';
import {TextG12, TextG14} from '../../../components/typography';
import useAuth from '../../../hooks/useAuth';

interface InSyncCardProps {
  profileName: string;
  profilePhotoUrl: string;
  sharedTimes: {label: string; emoji: string}[];
  sharedEvents: {id: number; title: string}[];
}

const InSyncCard = ({profileName, profilePhotoUrl, sharedTimes, sharedEvents}: InSyncCardProps) => {
  if (sharedTimes.length === 0 && sharedEvents.length === 0) return null;

  const {user} = useAuth();

  return (
    <Box mx={4} mb={6} bg="#2D2D2D" borderRadius="16px" p={4}>
      <HStack spacing={3} mb={3}>
        <AvatarGroup size="sm" spacing="-8px">
          <Avatar name={user?.name} src={user?.profilePhotoUrl} />
          <Avatar name={profileName} src={profilePhotoUrl} />
        </AvatarGroup>
        <TextG14 mt="0" color="white" fontWeight="700">
          You are in sync!
        </TextG14>
      </HStack>

      <VStack align="flex-start" spacing={2}>
        {sharedTimes.length > 0 && (
          <TextG14 mt="0" color="white" lineHeight="20px">
            <Box as="span" fontWeight="700">
              Shared time:{' '}
            </Box>
            {sharedTimes.map((t, i) => (
              <React.Fragment key={i}>
                {t.emoji} {t.label}{i < sharedTimes.length - 1 ? ', ' : ''}
              </React.Fragment>
            ))}
          </TextG14>
        )}
        {/* {sharedEvents.length > 0 && (
          <TextG14 mt="0" color="white" lineHeight="20px">
            <Box as="span" fontWeight="700">
              You both saved:{' '}
            </Box>
            {sharedEvents.map((e, i) => (
              <React.Fragment key={e.id}>
                <Box as="span" textDecoration="underline" cursor="pointer">
                  {e.title}
                </Box>
                {i < sharedEvents.length - 1 ? ', ' : ''}
              </React.Fragment>
            ))}
          </TextG14>
        )} */}
      </VStack>
    </Box>
  );
};

export default InSyncCard;
